

export class FormConstants {
  static minChar: any;

  static get weekDaysMapping(): any {
    return {
      SUN: 'w0',
      MON: 'w1',
      TUE: 'w2',
      WED: 'w3',
      THU: 'w4',
      FRI: 'w5',
      SAT: 'w6'
    };
  }

  static get errorMessages(): any {
    return {
      required: 'This field is mandatory',
      phone: 'Please enter a valid phone number',
      email: 'Please enter a valid email address',
      pattern: 'Please enter a valid value',
      outsideBounds: 'Location is outside city bounds',
      airportRequired: 'Location must be an airport',
      formError: 'Form filled incorrectly or not complete',
      minlength: 'Please enter min' + ' ' + this.minChar + ' ' + 'characters',
      payerReq: 'Please select a payer',
      etsMobileMandate: 'Please set the mobile number in ETS first'
    };
  }

  static get elementTypes(): any {
    return {
      text: 'textbox',
      number: 'number_input',
      incrementor: 'incrementor',
      radio: 'radio_Button',
      toggle: 'toggle_button',
      dropdown: 'dropdown',
      dropdownAndInput: 'dropdown_input',
      dropdownAndSearch: 'dropdown_search',
      dropdownAndSearchAndInput: 'dropdown_search_input',
      searchAndSelect: 'search_select',
      searchOrAdd: 'search_add',
      googleAddress: 'google_address_search',
      googleAddressAndInput: 'google_address_search_input',
      timepicker: 'timepicker',
      datetimepicker: 'dateTimePicker',
      datepicker: 'datepicker',
      multiSelect: 'multiSelect'
    };
  }

  static getElementType(type: string): string {
    const index = Object.values(FormConstants.elementTypes).indexOf(type);
    return Object.keys(FormConstants.elementTypes)[index];
  }
  static setMinChar(char) {
    this.minChar = char;
  }
}


